<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-13" id="_idParaDest-8"><span class="CharOverride-9">Hours before daylight on January 31, 1968, the first day of Tet, the Lunar New Year, nearly ten thousand North Vietnamese Army (NVA) and Viet Cong (VC) troops descended from hidden camps in the Central Highlands and overran the city of Hue, the historical capital of Vietnam. It was an extraordinarily bold and shocking move, taking the third-largest city in South Vietnam several years after America’s military intervention was supposed to have shifted the war decisively in Saigon’s favor. The National Liberation Front,<a id="_idTextAnchor000"></a></span><span href="#/eBook_V455773#_idTextAnchor1020" title="Link target outside of Sample"><span class="CharOverride-13">1</span></span><span class="CharOverride-9"> as the coalition of Communist forces called itself, had achieved complete surprise, taking all of Hue save for two embattled compounds, one an Army of the Republic of Vietnam (ARVN) base in the city’s north, and the other a small post for American military advisers in its south. Both had no more than a few hundred men, and were surrounded and in danger of being overrun.</span></p>
<p class="Epigraph ParaOverride-14" xml:lang="en-US">It would require twenty-four days of terrible fighting to take the city back. The Battle of Hue would be the bloodiest of the Vietnam War, and a turning point not just in that conflict, but in American history. When it was over, debate concerning the war in the United States was never again about winning, only about how to leave. And never again would Americans fully trust their leaders.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45577.vue?40c9401b